const closeButtonLabel = "Uždaryti";
const ltLT = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  ltLT as default
};
